<template>
  <div>
    <router-view />

    <div class="tab-options" v-if="options.length">
      <router-link v-for="(data, index) in options" :key="index"
              :to="({name: data.route})"
              :class="{'tab-highlight': $route.name === data.route}">
        {{data.name}}
      </router-link>
    </div>

    <unprivilege-panel v-if="getterUnprivilegePage" :title="getterUnprivilegePage"
                :css="'short-height'" />
    <router-view v-else name="more" />
  </div>
</template>

<script>
import UnprivilegePanel from '@/components/global/UnprivilegePanel'
import { mapGetters } from 'vuex'

export default {
  name: 'SubSectionLayout',
  components: { UnprivilegePanel },
  data () {
    return {
      options: []
    }
  },
  created () {
    this.populateData()
  },
  computed: {
    ...mapGetters(['getterUnprivilegePage', 'hasVaChilds'])
  },
  watch: {
    hasVaChilds (newVal) {
      if (newVal) {
        this.options.push(
          {
            name: 'Sub Virtual Accounts',
            route: 'SubVaList'
          }
        )
      }
    }
  },
  methods: {
    populateData () {
      const path = this.$route.path
      if (path.startsWith('/virtual_accounts')) {
        this.options = [
          {
            name: 'Statements',
            route: 'VATransactions'
          },
          {
            name: 'Invalid Credits',
            route: 'VAIdInvalidCredits'
          }
        ]
      } else if (path.startsWith('/bulk_imports')) {
        this.options = [
          {
            name: 'Processed',
            route: 'ImportProcessedTxns'
          },
          {
            name: 'Unprocessed',
            route: 'ImportUnprocessedTxns'
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/tabOptions.scss';

  .tab-options {
    margin-top: 15px;
  }
</style>
